module.exports = __webpack_public_path__ + "static/media/unitTick.303c5dbf.svg";